import { Component, OnInit, Inject } from '@angular/core';
import { CtxTagBuilderService } from './ctx-tag-builder.service';
import { Argument, CtxTag } from './ctx-tag-builder.model';
import { SelectType } from '../../cpq-select/cpq-select.component';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormulaBuilderConfig } from '../cpq-formula-builder.model';
import { Attribute } from '../../../product-module/add-edit-attribute/attribute.model';

@Component({
    selector: 'ctx-tag-builder',
    templateUrl: 'ctx-tag-builder.component.html',
    styleUrls: ['./ctx-tag-builder.component.scss'],
    providers: [CtxTagBuilderService],
    standalone: false
})

export class CtxTagBuilderComponent implements OnInit {

    public initialTags: Array<CtxTag>;
    public selectedTags: Array<CtxTag> = new Array<CtxTag>();
    public errorMessage: string;
    public SelectType = SelectType;
    public ctxFormula;
    public attribute: Attribute = new Attribute();
    private ctxPlaceholder = '@ctxValue@';
    private ctxFormulaTemplate = `<*CTX ( @ctxValue@ )*>`;

    constructor(private service: CtxTagBuilderService,
        public dialogRef: MatDialogRef<CtxTagBuilderComponent>,
        @Inject(MAT_DIALOG_DATA) public data: FormulaBuilderConfig) {
            this.dialogRef.disableClose = true;
         }

    ngOnInit(): void {
        this.service.getInitData().subscribe(response => {
            this.initialTags = response.sort((a,b) => a.text.localeCompare(b.text));
        });

        this.ctxFormula = '<*CTX( )*>';
    }

    initalTagSelected(id: number){
        this.selectedTags = new Array<CtxTag>();
        this.deselectArgument(0);

        if(id === null) {
            this.createCtxTag(this.selectedTags);
            return;
        }

        this.selectedTags[0] = this.initialTags.find(t => t.id === id);

        if(this.selectedTags[0].text === "Quote") {
            this.service.getFirstLevelQuoteObjects(this.selectedTags[0].id - 1, this.data.productId, null, this.data.containerId).subscribe(response => {
                this.selectedTags[0] = response;
                if (this.selectedTags[0].children) {
                    this.selectedTags[0].children = this.selectedTags[0].children.sort((a,b) => a.text.localeCompare(b.text));
                }
            })
        }
        else {
            this.service.getTagByIndex(this.selectedTags[0].id - 1, this.data.productId, null, this.data.containerId).subscribe(response => {
                this.selectedTags[0] = response;
                if (this.selectedTags[0].children) {
                    this.selectedTags[0].children = this.selectedTags[0].children.sort((a,b) => a.text.localeCompare(b.text));
                }
            })
        }
        
        this.createCtxTag(this.selectedTags);
    }

    argumentSelected(id: number, tagIndex: number) {
        const argument = this.selectedTags[tagIndex].arguments.find(arg => arg.id === id);

        if(tagIndex === 0 && id) {
            switch(this.selectedTags[0].text) {
                case "Container":
                    this.selectedTags.splice(tagIndex + 1, this.selectedTags.length);                
                    this.service.getTagByIndex(this.selectedTags[0].id, this.data.productId, argument.text, 0).subscribe(response => {
                        this.loadContainerTags(response, argument);
                    });
                    break;
            }
        } else (tagIndex === 0 && id === null); {
            this.selectedTags[tagIndex].argument = null;
        }

        this.selectedTags[tagIndex].argument = argument ? argument.text : '';

        this.createCtxTag(this.selectedTags);
    }

    tagSelected(id: number, tags: Array<CtxTag>, tagIndex: number) {
        if(id === null) {
            this.selectedTags.splice(tagIndex, this.selectedTags.length);
            this.createCtxTag(this.selectedTags);

            return
        }

        if(tagIndex < this.selectedTags.length) {
            this.selectedTags.splice(tagIndex, this.selectedTags.length);

            this.deselectArgument(tagIndex);
        }

        const tag = tags.find(t => t.id === id);
        this.selectedTags[tagIndex] = tag;
        this.selectedTags[tagIndex].argument = '';

        if(tagIndex === 1 && this.selectedTags[0].text === "Quote") {
            this.service.getOtherLevelsObjectsForSelectedQuoteObject(this.selectedTags[0].id, id - 1, this.data.productId, null, this.data.containerId).subscribe(response => {
                this.selectedTags[tagIndex].children = response.sort((a,b) => a.text.localeCompare(b.text));
            })
        }
        else {
            if (tag.children) {
                this.selectedTags[tagIndex].children = tag.children.sort((a,b) => a.text.localeCompare(b.text));
            }
        }

        this.createCtxTag(this.selectedTags);
    }

    switchToEditableArgument(tag: CtxTag) {
        tag.hasEditableArgument = !tag.hasEditableArgument;

        if (!tag.hasEditableArgument) {
            const argument = tag.arguments.find(arg => arg.text === tag.argument);
            if (argument) {
                tag.argument = argument.text;
            } else {
                tag.argument = '';
            }
        }

        this.createCtxTag(this.selectedTags);
    }

    insertEditableArgument() {
        this.createCtxTag(this.selectedTags);
    }

    pushCtxTagToFormula(formula: string) {
        if(!formula){
            this.dialogRef.close('');
        }
        else {
            this.service.checkCtxTagSyntax(formula).subscribe(response => {
                if (response.isValid) {
                    this.dialogRef.close(formula);
                } else {
                    this.errorMessage = response.message ? response.message : 'Error: undefined';
                }
            });
        }
    }

    cancel() {
        this.dialogRef.close('');
    }

    private deselectArgument(tagIndex: number) {
        var argumentInput = document.getElementById(`selectArgument${tagIndex}`) as HTMLInputElement;
        if(argumentInput) {
            argumentInput.value = '';
        }
    }

    private loadContainerTags(tag: CtxTag, argument: Argument) {
        this.selectedTags = Array<CtxTag>();
        this.selectedTags[0] = tag;
        this.selectedTags[0].argument = argument ? argument.text : '';
        if (this.selectedTags[0].children) {
            this.selectedTags[0].children = this.selectedTags[0].children.sort((a,b) => a.text.localeCompare(b.text));
        }
    }

    // Example formula: <*CTX(Product.Attribute(Jeca me smara).Label.Translated)*> 
    private createCtxTag(selectedTags: Array<CtxTag>) {
        let tag = '';

        selectedTags.forEach(selectedTag => {
            if (selectedTag.hasArgument) {
                if (selectedTag.argument) {
                    // Product.Attribute(Attribute name) - arguments will be added here (in this example Attribute name).
                    tag = `${tag}${selectedTag.text}(${selectedTag.argument}).`;
                } else {
                    if(selectedTag.hasEditableArgument) {
                        tag = `${tag}${selectedTag.text}().`;
                    }
                    else {
                        tag = `${tag}${selectedTag.text}.`;
                    }
                }
            } else {
                tag = `${tag}${selectedTag.text}.`;
            }
        })

        // Product.Attribute(Jeca me smara).Label.Translated. <- This will remove last .
        tag = tag.substring(0, tag.length - 1);

        this.ctxFormula = this.ctxFormulaTemplate.replace(this.ctxPlaceholder, tag);
    }
}